import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=677dcee9&scoped=true"
import script from "./Editable.vue?vue&type=script&lang=ts"
export * from "./Editable.vue?vue&type=script&lang=ts"
import style0 from "./Editable.vue?vue&type=style&index=0&id=677dcee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677dcee9",
  null
  
)

export default component.exports